import { createContext } from "react";

const ThemesContext = createContext({
  darkTheme: true,
});

export default ThemesContext;
